<template>
  <div>
    <div>
      <div slot="no-body" class="tabs-container pt-6" id="view-customer-tab">
        <div style="margin-right: auto; font-size: 1.5rem; font-weight: 550">
          {{ $t("entity.label.financial_transactions") }}
        </div>
        <div class="container-moreinfo">
          <div class="vx-row">
            <vs-tabs
              alignment="fixed"
              v-model="activeTab"
              class="tab-action-btn-fill-conatiner"
            >
              <vs-tab :label="$t('customers.label.all')">
                <div class="tab-text">
                  <vs-table
                    :max-items="5"
                    pagination
                    search
                    :data="transactions"
                    @selected="handelSelected"
                  >
                    <template slot="header">
                      <div class="mr-2 mb-1 order-1">
                        <vs-button
                          color="primary"
                          icon-pack="feather"
                          icon="icon-file-plus"
                          class="truncate"
                          @click="handleCsvPdf"
                          size="small"
                          >{{ $t("customers.label.csv_pdf") }}</vs-button
                        >
                      </div>
                      <!-- <div class="mr-2 mb-1 order-1">
                      <vs-button
                        color="primary"
                        icon-pack="feather"
                        icon="icon-sliders"
                        class="truncate"
                        @click="AdjustmentPopup = true"
                        size="small"
                        >{{ $t("button.adjustment") }}</vs-button
                      >
                    </div> -->
                    </template>
                    <template slot="thead">
                      <vs-th>{{ $t("customers.label.id") }}</vs-th>
                      <vs-th>{{ $t("customers.label.transaction_date") }}</vs-th>
                      <vs-th>{{ $t("customers.label.transaction_type") }}</vs-th>
                      <vs-th>{{ $t("customers.label.category") }}</vs-th>
                      <vs-th>{{ $t("customers.label.credit_amount") }}</vs-th>
                      <vs-th>{{ $t("customers.label.debit_amount") }}</vs-th>
                    </template>
                    <template slot-scope="{ data }">
                      <vs-tr
                        :key="index"
                        :data="transaction"
                        v-for="(transaction, index) in data"
                      >
                        <vs-td :data="transaction.transactionId">{{
                          transaction.transactionId
                        }}</vs-td>
                        <vs-td :data="getDate(transaction.transDate)">{{
                          getDate(transaction.transDate)
                        }}</vs-td>

                        <vs-td :data="transaction.transactionType">{{
                          transaction.transactionType
                        }}</vs-td>
                        <vs-td :data="transaction.transactionCategory">{{
                          transaction.transactionCategory
                        }}</vs-td>

                        <vs-td :data="transaction.creditAmount">{{
                          transaction.creditAmount.toFixed(2)
                        }}</vs-td>
                        <vs-td :data="transaction.amount">{{
                          transaction.amount.toFixed(2)
                        }}</vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </vs-tab>
              <vs-tab :label="$t('customers.label.charges')">
                <div class="tab-text mx-2">
                  <vs-table
                    :max-items="5"
                    pagination
                    search
                    :data="chargeList.pageItems"
                    @selected="handelSelected"
                    class="w-full"
                  >
                    <template slot="header"> </template>
                    <template slot="thead">
                      <vs-th>{{ $t("customers.label.id") }}</vs-th>
                      <vs-th>{{ $t("customers.label.transaction_date") }}</vs-th>
                      <vs-th class="min-w-100">{{
                        $t("customers.label.charge_description")
                      }}</vs-th>
                      <vs-th class="thead-width">{{
                        $t("customers.label.start_date")
                      }}</vs-th>
                      <vs-th class="thead-width">{{
                        $t("customers.label.end_date")
                      }}</vs-th>
                      <vs-th>{{ $t("customers.label.charge_code") }}</vs-th>
                      <vs-th>{{ $t("customers.label.charge_type") }}</vs-th>
                      <vs-th>{{ $t("customers.label.amount") }}</vs-th>
                    </template>
                    <template slot-scope="{ data }">
                      <vs-tr
                        :key="index"
                        :data="transaction"
                        v-for="(transaction, index) in data"
                      >
                        <vs-td :data="transaction.transactionId">{{
                          transaction.transactionId
                        }}</vs-td>
                        <vs-td :data="transaction.transactionDate">
                          {{ getDate(transaction.transactionDate) }}
                        </vs-td>
                        <vs-td :data="transaction.planName"
                          >{{ transaction.planName }} : {{ transaction.product }} -
                          {{ transaction.chargeCode }}</vs-td
                        >
                        <vs-td :data="transaction.startDate">{{
                          getDate(transaction.startDate)
                        }}</vs-td>
                        <vs-td :data="transaction.endDate">{{
                          getDate(transaction.endDate)
                        }}</vs-td>
                        <vs-td :data="transaction.chargeCode">{{
                          transaction.chargeCode
                        }}</vs-td>
                        <vs-td :data="transaction.chargeType">{{
                          transaction.chargeType
                        }}</vs-td>
                        <vs-td :data="transaction.amount">{{
                          transaction.amount.toFixed(2)
                        }}</vs-td>
                        <!-- <vs-td> -->
                        <!-- <feather-icon
                        v-if="transaction.transactionCategory === 'Usage'"
                        title="View Usage"
                        icon="EyeIcon"
                        @click.stop="
                          handelSelected(
                            transaction.transactionId,
                            transaction.clientId
                          )
                        "
                        class="mr-1"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      /> -->
                        <!-- <feather-icon
                          title="cancel Payment"
                          icon="XIcon"
                          @click.stop="
                            cancelRemarkPopup = true;
                            transactionId = transaction.transactionId;
                          "
                          svgClasses="w-5 h-5 hover:text-primary stroke-current"
                        /> -->
                        <!-- </vs-td> -->
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </vs-tab>
              <vs-tab :label="$t('customers.label.journals')">
                <div class="tab-text mx-2">
                  <vs-table
                    :max-items="5"
                    pagination
                    search
                    @selected="handelSelected"
                    :data="transactions"
                  >
                    <template slot="header">
                      <!-- ADD NEW -->
                    </template>
                    <template slot="thead">
                      <vs-th>{{ $t("customers.label.user_name") }}</vs-th>
                      <vs-th>{{ $t("customers.label.id") }}</vs-th>
                      <vs-th>{{ $t("customers.label.transaction_date") }}</vs-th>
                      <vs-th>{{ $t("customers.label.transaction_type") }}</vs-th>
                      <vs-th>{{ $t("customers.label.category") }}</vs-th>
                      <vs-th>{{ $t("customers.label.credit_amount") }}</vs-th>
                      <vs-th>{{ $t("customers.label.debit_amount") }}</vs-th>
                    </template>
                    <template slot-scope="{ data }">
                      <vs-tr
                        :key="index"
                        :data="transaction"
                        v-for="(transaction, index) in data"
                      >
                        <vs-td :data="transaction.userName">{{
                          transaction.userName
                        }}</vs-td>

                        <vs-td :data="transaction.transactionId">{{
                          transaction.transactionId
                        }}</vs-td>
                        <vs-td :data="getDate(transaction.transDate)">{{
                          getDate(transaction.transDate)
                        }}</vs-td>

                        <vs-td :data="transaction.transactionType">{{
                          transaction.transactionType
                        }}</vs-td>
                        <vs-td :data="transaction.transactionCategory">{{
                          transaction.transactionCategory
                        }}</vs-td>

                        <vs-td :data="transaction.creditAmount">{{
                          transaction.creditAmount.toFixed(2)
                        }}</vs-td>
                        <vs-td :data="transaction.amount">{{
                          transaction.amount.toFixed(2)
                        }}</vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </vs-tab>
              <vs-tab :label="$t('customers.label.deposit')">
                <div class="tab-text mx-2">
                  <vs-table
                    :max-items="5"
                    pagination
                    search
                    @selected="handelSelected"
                    :data="transactions"
                  >
                    <template slot="header">
                      <!-- ADD NEW -->
                    </template>
                    <template slot="thead">
                      <vs-th>{{ $t("customers.label.user_name") }}</vs-th>
                      <vs-th>{{ $t("customers.label.id") }}</vs-th>
                      <vs-th>{{ $t("customers.label.transaction_date") }}</vs-th>
                      <vs-th>{{ $t("customers.label.transaction_type") }}</vs-th>
                      <vs-th>{{ $t("customers.label.category") }}</vs-th>
                      <vs-th>{{ $t("customers.label.credit_amount") }}</vs-th>
                      <vs-th>{{ $t("customers.label.debit_amount") }}</vs-th>
                      <vs-th class="tHeadCenter">{{
                        $t("customers.label.action")
                      }}</vs-th>
                    </template>
                    <template slot-scope="{ data }">
                      <vs-tr
                        :key="index"
                        :data="transaction"
                        v-for="(transaction, index) in data"
                      >
                        <vs-td :data="transaction.userName">{{
                          transaction.userName
                        }}</vs-td>
                        <vs-td :data="transaction.transactionId">{{
                          transaction.transactionId
                        }}</vs-td>
                        <vs-td :data="getDate(transaction.transDate)">{{
                          getDate(transaction.transDate)
                        }}</vs-td>
                        <vs-td :data="transaction.transactionType">{{
                          transaction.transactionType
                        }}</vs-td>
                        <vs-td :data="transaction.transactionCategory">{{
                          transaction.transactionCategory
                        }}</vs-td>
                        <vs-td :data="transaction.creditAmount">{{
                          transaction.creditAmount.toFixed(2)
                        }}</vs-td>
                        <vs-td :data="transaction.amount">{{ transaction.amount }}</vs-td>
                        <vs-td class="whitespace-no-wrap">
                          <div class="container_img">
                            <feather-icon
                              v-if="transaction.transactionCategory == 'Deposit'"
                              title="Refund"
                              icon="PocketIcon"
                              @click="refundAccess(transaction)"
                              class="mr-1 icon_row"
                              svgClasses="w-5 h-5 stroke-current"
                            />
                          </div>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </vs-tab>
            </vs-tabs>
          </div>
        </div>
        <div class="vx-row" v-show="false">
          <div class="vx-col w-full mt-3">
            <form>
              <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                <div class="vx-col mb-2 md:w-1/2 lg:w-1/2">
                  <small class="date-label font-semibold">{{
                    $t("customers.label.adjustment_date")
                  }}</small>
                  <datepicker
                    :placeholder="$t('customers.label.adjustment_date')"
                    class
                    v-model="adjustments.date"
                  ></datepicker>
                </div>
                <div class="vx-col mb-2 md:w-1/2 lg:w-1/2">
                  <small class="date-label font-semibold">{{
                    $t("customers.label.adjustment_code")
                  }}</small>
                  <v-select
                    label="adjustmentCode"
                    :placeholder="$t('customers.label.SelectAdjustementCode')"
                    v-model="adjustments.adjustmentCode"
                    :options="getAdjustments.data"
                    :reduce="(adjustmentCode) => adjustmentCode.id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                  />
                </div>
                <div class="vx-col mb-2 md:w-1/2 lg:w-1/2">
                  <vs-input
                    :label="$t('customers.label.adjustment_amount')"
                    class="w-full font-semibold"
                    v-model="adjustments.adjustmentAmount"
                    icon-no-border
                  />
                </div>
                <div class="vx-col mb-2 md:w-1/2 lg:w-1/2">
                  <small class="date-label font-semibold">{{
                    $t("customers.label.adjustment_amount_type")
                  }}</small>
                  <v-select
                    label="discountType"
                    :placeholder="$t('customers.label.SelectAdjustmentType')"
                    :options="getAdjustments.discountOptions"
                    v-model="adjustments.discount"
                    :reduce="(discountType) => discountType.discountType"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                  />
                </div>
                <div class="vx-col mb-2 w-full">
                  <small class="date-label font-semibold">{{
                    $t("customers.label.notes")
                  }}</small>
                  <vs-textarea v-model="adjustments.notes" />
                </div>
              </div>

              <div class="vx-row">
                <span class="ml-4 mr-1">
                  <vs-button type="border">{{ $t("customers.label.clear") }}</vs-button>
                </span>
                <span class="ml-1 mr-2">
                  <vs-button @click="addAdjustments">{{
                    $t("customers.label.submit")
                  }}</vs-button>
                </span>
              </div>
            </form>
          </div>
        </div>
        <div class="centerx">
          <vs-popup
            classContent="popup-example"
            :title="$t('customers.label.download_financial_summary_data')"
            :active.sync="downloadDoc"
            class="popup-close mid-popup"
          >
            <ValidationObserver ref="observer1">
              <form>
                <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                  <div class="vx-col mb-2 w-full">
                    <small class="date-label font-semibold"
                      >{{ $t("customers.label.format_type")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.format_type')"
                      :key="resetKey"
                    >
                      <v-select
                        label="item"
                        :placeholder="$t('customers.label.SelectFormat')"
                        :options="format"
                        v-model="csvPdf.format"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col mb-2 w-full">
                    <small class="date-label font-semibold"
                      >{{ $t("customers.label.select_from_date")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.select_from_date')"
                      :key="resetKey"
                    >
                      <datepicker
                        :placeholder="$t('customers.label.select_from_date')"
                        v-model="csvPdf.startDate"
                      ></datepicker>
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col mb-2 w-full">
                    <small class="date-label font-semibold"
                      >{{ $t("customers.label.select_to_date")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.select_to_date')"
                      :key="resetKey"
                    >
                      <datepicker
                        :placeholder="$t('customers.label.select_to_date')"
                        v-model="csvPdf.endDate"
                      ></datepicker>
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="center">
                  <span class="ml-1 mr-2">
                    <vs-button @click="addDocument">{{
                      $t("customers.label.download")
                    }}</vs-button>
                  </span>
                </div>
              </form>
            </ValidationObserver>
          </vs-popup>
        </div>
      </div>
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('customers.label.payment_reversal')"
          :active.sync="cancelRemarkPopup"
          class="popup-close mid-popup"
        >
          <form>
            <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
              <div class="vx-col mb-2 w-full">
                <small class="date-label font-semibold">{{
                  $t("customers.label.cancel_remark")
                }}</small>
                <vs-textarea v-model="cancelremark" />
              </div>
            </div>

            <div class="vx-row">
              <span class="ml-4 mr-1">
                <vs-button type="border" @click="cancelRemarkPopup = false">{{
                  $t("customers.label.close")
                }}</vs-button>
              </span>
              <span class="ml-1 mr-2">
                <vs-button @click="paymentReversal">{{
                  $t("customers.label.confirm")
                }}</vs-button>
              </span>
            </div>
          </form>
        </vs-popup>
      </div>
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('customers.label.refund')"
          :active.sync="refundAccessPopup"
          class="popup-close small-popup"
        >
          <form>
            <div class="vx-row">
              <div class="vx-col sm:w-full w-full text-xl text-center pb-3">
                {{$t("customers.label.AreYouSure?")}}
              </div>
            </div>
            <div class="center">
              <span class="ml-1 mr-1">
                <vs-button
                  @click="handleSubmitRefund"
                  class="footerButton-next"
                  style="top: 0px"
                  >{{ $t("customers.label.confirm") }}</vs-button
                >
              </span>
            </div>
            <div style="height: 20px"></div>
          </form>
        </vs-popup>
      </div>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import { quillEditor } from "vue-quill-editor";
import vSelect from "vue-select";
import moment from "moment";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { BUCKET_BASE_URL } from "@/http/index";
const adjustmentObj = {
  date: moment().format("DD MMMM YYYY"),
  adjustmentCode: "",
  discount: "",
  notes: "",
  adjustmentAmount: "",
};
export default {
  props: ["clientId"],
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      resetKey: 0,
      switch1: true,
      serviceOrder: [],
      amountOptions: [{ value: 1000, label: "1000" }],
      identifier: false,
      additionalInfo: false,
      documentsUploads: false,
      creditCardDetails: false,
      adjustment2: false,
      cancelRemarkPopup: false,
      downloadDoc: false,
      cancelremark: "",
      transactionId: "",
      adjustment: { ...adjustmentObj },
      AdjustmentPopup: false,
      refundAccessPopup: false,
      depositId: "",
      refundAmount: "",
      activeTab: 0,
      csvPdf: {
        format: "",
        startDate: moment().subtract(15, "d").format("DD MMMM YYYY"),
        endDate: moment().subtract(0, "d").format("DD MMMM YYYY"),
      },
      adjustments: {
        ...adjustmentObj,
      },
      format: ["csv", "pdf"],
      chargeList: null,
    };
  },
  components: {
    quillEditor,
    Datepicker,
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      clientDepositListData: (state) => state.customer.clientDepositList,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
    transactions() {
      return this.$store.getters["customerAccount/getTransactionDetails"];
    },
    getAdjustments() {
      return this.$store.getters["customer/getAdjustmentsTemplate"];
    },
    adjustmentDatas() {
      return this.$store.getters["entity/getAdjustmentsTemplate"];
    },
  },
  methods: {
    async getCharge() {
      const res = await this.$store.dispatch("customer/fetchChargeData", this.clientId);
      this.chargeList = res.data;
    },
    getDate(dateArray) {
      const date = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
      const formattedDate = moment(date).format(this.formattedDate);
      return formattedDate;
    },
    async getTransactions(params) {
      try {
        this.$store.dispatch("customerAccount/setTransactionDetails", {
          params: params,
          clientId: this.clientId,
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async adjustmentTemplate() {
      try {
        await this.$store.dispatch("entity/setAdjustmentsTemplate");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    handleCsvPdf() {
      this.resetKey++;
      this.downloadDoc = true;
    },

    async addDocument() {
      const isValid = await this.$refs.observer1.validate();
      if (!isValid) return;

      try {
        // const fromDate = moment(this.csvPdf.startDate).format("DD-MM-YYYY");
        // const toDate = moment(this.csvPdf.endDate).format("DD-MM-YYYY");

        window.open(
          BUCKET_BASE_URL +
            "/financialTransactions/download/" +
            this.clientId +
            `?downloadType=${this.csvPdf.format}&fromDate=1690828200000&toDate=1693491630929&tenantIdentifier=default`
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async addAdjustments() {
      try {
        const adjustmentData = {
          adjustment_type: this.adjustments.discount,
          withtax: false,
          amount_paid: this.adjustments.adjustmentAmount,
          adjustment_code: this.adjustments.adjustmentCode,
          Remarks: this.adjustments.notes,
          locale: "en",
          dateFormat: "dd MMMM yyyy",
          adjustment_date: this.adjustments.date,
          billpoId: null,
        };
        const payload = {
          id: this.clientId,
          data: adjustmentData,
        };
        await this.$store.dispatch("customerAccount/createAdjustmentsAction", payload);
        this.$router.push({
          name: "View Customer",
          params: { id: this.clientId },
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    printPayment(type, id) {
      window.open(
        BUCKET_BASE_URL +
          "/billmaster/" +
          type.toLowerCase() +
          "/" +
          this.clientId +
          "/" +
          id +
          "?email=false&tenantIdentifier=default"
      );
    },
    async paymentReversal() {
      try {
        const cancelRemarkObj = {
          cancelRemark: this.cancelremark,
          clientPoId: 0,
        };
        await this.$store.dispatch("customerPayment/cancelPaymentAction", {
          id: this.transactionId,
          data: cancelRemarkObj,
        });

        this.cancelremark = "";
        this.cancelRemarkPopup = false;
        this.getTransactions();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    refundAccess(transition) {
      this.depositId = transition.transactionId;
      this.refundAmount = transition.amount;
      this.refundAccessPopup = true;
    },
    async handleSubmitRefund() {
      try {
        const payload = {
          id: this.depositId,
          data: {
            refundAmount: this.refundAmount,
            refundMode: 1,
            locale: "en_IN",
          },
        };
        await this.$store.dispatch("customer/addRefundAction", payload);
        this.refundAccessPopup = false;
        this.getTransactions({});
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Refund Submit Successful!",
          type: "success",
        });
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");
      }
    },
    async depositTabClick() {
      try {
        const id = this.clientId;
        await this.$store.dispatch("customer/setClientDepositListAction", id);
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");
      }
    },
    handelSelected(transaction) {
      if (transaction.transactionType == "SERVICE CHARGES") {
        this.$router.push({
          name: "View Financial Transaction",
          params: {
            id: transaction.transactionId,
            clientId: this.clientId,
            amount: transaction.amount,
          },
        });
      } else return;
    },
  },
  mounted() {
    this.getTransactions({});
    this.getCharge();
    this.adjustmentTemplate();
  },
  watch: {
    activeTab(newValue) {
      if (newValue === 0) this.getTransactions({});
      else if (newValue === 1) this.getTransactions({ type: "DEBIT" });
      else if (newValue === 2) this.getTransactions({ type: "ADJUSTMENT" });
      else if (newValue === 3) this.getTransactions({ type: "JOURNAL+VOUCHER" });
      else if (newValue === 4) this.getTransactions({ type: "DEPOSIT%26REFUND" });
      // this.depositTabClick();
    },
  },
};
</script>
<style lang="scss" scoped>
.vs-tabs--ul {
  width: 60%;
}
.my-search-box {
  .vs-table--search-input {
    max-width: 150px;
    height: 2.4rem;
  }
  .vs-table--search {
    margin-top: 0;
  }
}
.tab-text {
  position: relative;
  top: -4.3rem;
  left: 1rem;
  padding-right: 2rem;

  overflow: visible;
}
::v-deep .con-vs-tabs {
  background: transparent !important;
}
::v-deep .con-vs-tabs .con-slot-tabs {
  overflow: visible;
}
.thead-width {
  min-width: 7.5rem;
}
</style>
